module.exports = __webpack_public_path__ + "img/projek21.252f79ae.png";